export default __webpack_public_path__ + "static/media/info-tooltip-acciones.aca3c499.svg";